export const getFirstImageUrl = (experience: any) => {
  if (!experience) {
    console.log('🖼️ Experience is undefined, using fallback image');
    return 'https://rendezvouswebsite.b-cdn.net/DSCF9542.JPG';
  }
  console.log('🖼️ Experience media:', experience?.media);
  if (experience.media && Array.isArray(experience.media) && experience.media.length > 0) {
    // Strictly use the image with order_index === 0
    const imageAtZero = experience.media.find((m: any) => m.type === 'image' && (m.order_index === 0 || m.order_index === null || m.order_index === undefined));
    if (imageAtZero) {
      console.log('🖼️ Using image with order_index 0:', imageAtZero);
      return imageAtZero.url;
    }
  }
  // Use homepage hero image as fallback
  console.log('🖼️ Using fallback image');
  return 'https://rendezvouswebsite.b-cdn.net/DSCF9542.JPG';
};

export const getCurrencySymbol = (currency?: string) => {
  const currencyMap: Record<string, string> = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    CAD: 'C$',
    AUD: 'A$'
  };
  
  return currencyMap[currency?.toUpperCase() ?? 'USD'] ?? '$';
};

export const getGoogleMapsUrl = (location: any) => {
  if (!location) return '';
  
  const address = [
    location.address,
    location.city,
    location.country
  ].filter(Boolean).join(', ');
  
  return `https://maps.google.com/?q=${encodeURIComponent(address)}`;
}; 